import React from "react";
import { ViewTodo } from "../../pages";

const ViewTodoContainer = ({ closeModal, item, tradingName }) => {
  return (
    <ViewTodo closeModal={closeModal} item={item} tradingName={tradingName} />
  );
};
export default ViewTodoContainer;
